export default "__VITE_PUBLIC_ASSET__95aec317__"